(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-infinite-collection')) {
    customElements.define('sc-infinite-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true' || this.initialized) return;
        this.initialized = true;
        this.grid = this.querySelector('[data-product-grid]');
        this.more = this.querySelector('[data-load-more]');
        this.status = this.querySelector('[data-load-status]');
        this.auto = this.querySelector('[data-auto]');
        this.next = this.more?.getAttribute('href');
        this.report();
        if (!this.next) return;
        this.onMore = (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.load(true);
        };
        this.more.addEventListener('click', this.onMore);
        this.querySelector('[data-pagination]')?.setAttribute('hidden', '');
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some(entry => entry.isIntersecting) && this.auto?.checked && !this.failed) this.load(false);
          }, { rootMargin: '0px 0px 350px 0px' });
          this.onAuto = () => {
            this.observer.disconnect();
            if (this.auto.checked && this.next && !this.failed) this.observer.observe(this.querySelector('[data-sentinel]'));
          };
          this.auto?.addEventListener('change', this.onAuto);
          this.querySelector('[data-auto-control]')?.removeAttribute('hidden');
          this.onAuto();
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.more?.removeEventListener('click', this.onMore);
        this.auto?.removeEventListener('change', this.onAuto);
        this.initialized = false;
        this.loading = false;
      }
      report() {
        const shown = Number(this.dataset.offset) + this.grid.children.length;
        this.status.textContent = this.dataset.progress.replace('[shown]', shown).replace('[total]', this.dataset.total);
      }
      async load(manual) {
        if (this.loading || !this.next || !this.isConnected) return;
        this.loading = true;
        this.observer?.disconnect();
        this.status.textContent = this.dataset.loading;
        this.more.setAttribute('aria-disabled', 'true');
        this.grid.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        this.controller = controller;
        try {
          const url = new URL(this.next, location.origin);
          if (url.origin !== location.origin) throw new Error('Invalid next page');
          url.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Page unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.isConnected || this.controller !== controller) return;
          const incoming = Array.from(doc.querySelectorAll('sc-infinite-collection')).find(el => el.dataset.section === this.dataset.section);
          const incomingGrid = incoming?.querySelector('[data-product-grid]');
          if (!incomingGrid || !incomingGrid.children.length) throw new Error('Invalid product page');
          const known = new Set(Array.from(this.grid.children, el => el.dataset.productId));
          const cards = Array.from(incomingGrid.children).filter(el => !known.has(el.dataset.productId));
          if (!cards.length) throw new Error('Repeated product page');
          cards.forEach(card => card.querySelectorAll('img').forEach(image => {
            image.loading = 'lazy';
            image.fetchPriority = 'auto';
          }));
          this.grid.append(...cards);
          const oldNext = this.next;
          this.next = incoming.querySelector('[data-load-more]')?.getAttribute('href');
          if (this.next === oldNext) this.next = null;
          this.failed = false;
          this.report();
          if (this.next) this.more.setAttribute('href', this.next);
          else {
            this.more.hidden = true;
            this.querySelector('[data-auto-control]')?.setAttribute('hidden', '');
            this.status.textContent += ' ' + this.dataset.end;
          }
          if (manual) cards[0].querySelector('a')?.focus({ preventScroll: true });
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.failed = true;
          this.status.textContent = this.dataset.error;
          this.querySelector('[data-pagination]')?.removeAttribute('hidden');
        } finally {
          if (this.controller === controller) {
            this.loading = false;
            this.more.removeAttribute('aria-disabled');
            this.grid.removeAttribute('aria-busy');
            if (this.next && this.auto?.checked && !this.failed && this.isConnected) this.observer?.observe(this.querySelector('[data-sentinel]'));
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
